import { Pipe, PipeTransform } from '@angular/core';
import { intervalToDuration } from 'date-fns';
import { convertNumberToStringAddingZeroIfLessThan10 } from '@app/utils/date';

@Pipe({ name: 'plSecondsToTime' })
export class SecondsToTimePipe implements PipeTransform {
  public transform(numberSeconds: number | undefined | null): string {
    if (numberSeconds) {
      const duration: Duration = intervalToDuration({ start: 0, end: numberSeconds * 1000 });
      let timeFormatted: string = '';
      if (duration.hours && duration.hours > 0) {
        timeFormatted += `${duration.hours}:`;
      }

      timeFormatted += `${convertNumberToStringAddingZeroIfLessThan10(duration.minutes)}:`;
      timeFormatted += `${convertNumberToStringAddingZeroIfLessThan10(duration.seconds)}`;
      return timeFormatted;
    }

    return '00:00';
  }
}
